import { Image,SimpleGrid,Box,Card,Stack, CardBody,Text,HStack,Link,Badge, Flex} from "@chakra-ui/react"
import { Tokens } from "../mirrorful/theme"
import ProjectCard from "./ProjectCard"
import { StageLight } from "./StageLight"
import { motion } from "framer-motion"
import Heading from "./Heading"
import AOS from 'aos';
import 'aos/dist/aos.css';
import { useEffect } from "react"
import {BiLogoNetlify} from "react-icons/bi"
import {AiFillGithub} from "react-icons/ai"

export default function Testprojects({id}){

  useEffect(() => {
    AOS.init();
  }, [])

    return (
      <>
       <div
       id={id}
        style={{
          scrollBehavior:"smooth",
          width: '100%',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          marginTop: '150px',
          marginBottom:'0px',
        }}
      >
        <StageLight/>
        <motion.div
          initial={{
            y: 40,
            opacity: 0.5,
          }}
          whileInView={{ y: 0, opacity: 1 }}
          viewport={{
            amount: 1,
            margin: '-5%',
          }}
          transition={{
            duration: 0.5,
          }}
          style={{
            marginTop: -20,
          }}
        >
          <Heading
            text={'My Projects'}
            size="md"
            style={{ marginTop: '64px', marginBottom: '32px', color: 'white' }}
          />
        </motion.div>
       
        </div>
        <SimpleGrid 
    columns={{
      base: 1,
      sm: 1,
      md: 3,
    }}
    gap= "16px"
    width= "90%"
    margin="auto"
    padding= "16px"
  >
        {/* three of these */}
      {/* <ProjectCard> */}
        <Card key={1}
        className="project-card"
       _hover={{
        boxShadow: `0 0 20px 3px ${Tokens.blue.shades['400']}`,

      }}
        background={"transparent"}
        direction={{
                    base: "column",
                  }}
                  overflow="hidden"
                  border={ `1px solid rgba(190, 190, 190, 0.2)`}
         borderRadius= '8px'
         background-image= {`linear-gradient(to bottom, #030518, #05071a, #06081b, #080a1d, #090b1f, #0a0c20, #0b0d21, #0c0e22, #0d0f23, #0e1023, #0e1024, #0f1125)`}
          backdropFilter= {`blur(10px)`}
          color= 'white'
          padding={"16px"}
        
                  >
                   
        <Image align={"left"} objectFit="cover" maxH={"200px"} src={"https://res.cloudinary.com/dsixdct6o/image/upload/v1689119521/Screenshot_2023-07-12_at_05.20.12_qt78tw.png"} />
     
                    <Stack>
                      <CardBody align="left" h={[null, "40vh"]}>

                        <Heading classname="project-title" size="sm" text={"Aurum Jewels"}/>
                         <div className="project-description">
                        <Text fontSize="sm" py={2}  classname="project-description">
                          {"A clone of CaratLane, an e-commerce website for selling jewelery."}
                        </Text>
                        </div>
                        <HStack spacing={2}>
                      
                            <a
                              
                              href="https://sparkly-malabi-79f4d0.netlify.app/"
                              target="_blank" rel="noopener noreferrer"
                              color="white"
                              className="project-deployed-link"
                            >
                              <BiLogoNetlify/>
                           
                             
                            </a>
                            <a
                              target="_blank" rel="noopener noreferrer"
                              href="https://github.com/Abhishree-codes/innocent-glove-9480"
                              color="white"
                              className="project-github-link"
                            >
                              <AiFillGithub/>
                           
                             
                            </a>
                       
                        </HStack>
                        <HStack className="project-tech-stack" flexWrap="wrap" pt={4} spacing={2}>
                          
                            <Badge
                              my={2}
                              
                              colorScheme={"white"}
                            >
                              HTML
                            </Badge>
                            <Badge
                              my={2}
                              
                              colorScheme={"white"}
                            >
                              CSS
                            </Badge>
                            <Badge
                              my={2}
                              
                              colorScheme={"white"}
                            >
                              JavaScript
                            </Badge>
                        
                        </HStack>
                      </CardBody>
                    </Stack>
                  </Card>
                  {/* </ProjectCard> */}
                  <Card key={2}  
                  className="project-card"
       _hover={{
        boxShadow: `0 0 20px 3px ${Tokens.blue.shades['400']}`,

      }}
       background={"transparent"}
       direction={{
                   base: "column",
                 }}
                 overflow="hidden"
                 border={ `1px solid rgba(190, 190, 190, 0.2)`}
         borderRadius= '8px'
         background-image= {`linear-gradient(to bottom, #030518, #05071a, #06081b, #080a1d, #090b1f, #0a0c20, #0b0d21, #0c0e22, #0d0f23, #0e1023, #0e1024, #0f1125)`}
         backdropFilter= {`blur(10px)`}
         color= 'white'
         padding={"16px"}
         
                 >
                  
       <Image align={"left"} objectFit="cover" maxH={"200px"} src={"https://res.cloudinary.com/dsixdct6o/image/upload/v1689120135/Screenshot_2023-07-12_at_05.31.54_u1ndb2.png"} />
    
                   <Stack>
                     <CardBody align="left" h={[null, "40vh"]}>

                       <Heading classname="project-title"  text={"TakeATrip"} size="sm"/>
                       <div className="project-description">
                       <Text fontSize="sm" py={2} classname="project-description">
                         {"An e-commerce website for booking trips. Design inspired by a tempelate from Dribble."}
                       </Text>
                       </div>
                       <HStack spacing={2} >
                     
                       <a
                              
                              href="https://sunny-cucurucho-f788c1.netlify.app/"
                              target="_blank" rel="noopener noreferrer"
                              color="white"
                              className="project-deployed-link"
                            >
                              <BiLogoNetlify/>
                           
                             
                            </a>
                            <a
                              target="_blank" rel="noopener noreferrer"
                              href="https://github.com/Abhishree-codes/devilish-bomb-2241"
                              color="white"
                              className="project-github-link"
                            >
                              <AiFillGithub/>
                           
                             
                            </a>
                      
                       </HStack>
                       <HStack className="project-tech-stack" flexWrap="wrap" pt={4} spacing={2}>
                         
                           <Badge
                             my={2}
                             
                             colorScheme={"white"}
                           >
                             HTML
                           </Badge>
                           <Badge
                             my={2}
                             
                             colorScheme={"white"}
                           >
                             CSS
                           </Badge>
                           <Badge
                             my={2}
                             
                             colorScheme={"white"}
                           >
                             JavaScript
                           </Badge>
                       
                       </HStack>
                     </CardBody>
                   </Stack>
                 </Card>
                 <Card key={3}  
                 className="project-card"
       _hover={{
        boxShadow: `0 0 20px 3px ${Tokens.blue.shades['400']}`,

      }}
       background={"transparent"}
       direction={{
                   base: "column",
                 }}
                 overflow="hidden"
                 border={ `1px solid rgba(190, 190, 190, 0.2)`}
         borderRadius= '8px'
         background-image= {`linear-gradient(to bottom, #030518, #05071a, #06081b, #080a1d, #090b1f, #0a0c20, #0b0d21, #0c0e22, #0d0f23, #0e1023, #0e1024, #0f1125)`}
         backdropFilter= {`blur(10px)`}
         color= 'white'
         padding={"16px"}
     
                 >
                  
       <Image align={"left"} objectFit="cover" maxH={"200px"} src={"https://res.cloudinary.com/dsixdct6o/image/upload/v1689120349/Screenshot_2023-07-12_at_05.35.26_phlspk.png"} boxShadow={ `0 0 50px 10px #1c1c42`} />
    
                   <Stack>
                     <CardBody align="left" h={[null, "40vh"]}>

                       <Heading classname="project-title"  text={"MedX"} size="sm">first</Heading>
                        <div className="project-description">
                       <Text fontSize="sm" py={2} classname="project-description">
                         {"An E-commerce platform offering medical services. Design inspired by a template from Dribble."}
                       </Text>
                       </div>
                       <HStack spacing={2}>
                       <a
                              
                              href="https://medx10980.netlify.app/"
                              target="_blank" rel="noopener noreferrer"
                              color="white"
                              className="project-deployed-link"
                            >
                              <BiLogoNetlify/>
                           
                             
                            </a>
                            <a
                              target="_blank" rel="noopener noreferrer"
                              href="https://github.com/Abhishree-codes/short-attraction-8970"
                              color="white"
                              className="project-github-link"
                            >
                              <AiFillGithub/>
                           
                             
                            </a>
                      
                       </HStack>
                       <HStack className="project-tech-stack" flexWrap="wrap" pt={4} spacing={2}>
                         
                           <Badge
                             my={2}
                             
                             colorScheme={"white"}
                           >
                             HTML
                           </Badge>
                           <Badge
                             my={2}
                             
                             colorScheme={"white"}
                           >
                             React
                           </Badge>
                           <Badge
                             my={2}
                             
                             colorScheme={"white"}
                           >
                             Chakra UI
                           </Badge>
                       
                       </HStack>
                     </CardBody>
                   </Stack>
                 </Card>
                 <Card key={4}  
                 className="project-card"
       _hover={{
        boxShadow: `0 0 20px 3px ${Tokens.blue.shades['400']}`,

      }}
       background={"transparent"}
       direction={{
                   base: "column",
                 }}
                 overflow="hidden"
                 border={ `1px solid rgba(190, 190, 190, 0.2)`}
         borderRadius= '8px'
         background-image= {`linear-gradient(to bottom, #030518, #05071a, #06081b, #080a1d, #090b1f, #0a0c20, #0b0d21, #0c0e22, #0d0f23, #0e1023, #0e1024, #0f1125)`}
         backdropFilter= {`blur(10px)`}
         color= 'white'
         padding={"16px"}
       
                 >
                  
       <Image align={"left"} objectFit="cover" maxH={"200px"} src={"https://res.cloudinary.com/dsixdct6o/image/upload/v1695073445/Screenshot_2023-09-19_at_03.13.36_grwtui.png"} boxShadow={ `0 0 50px 10px #1c1c42`} />
    
                   <Stack>
                     <CardBody align="left" h={[null, "40vh"]}>

                       <Heading classname="project-title"  text={"Charity Hero"} size="sm">first</Heading>
                       <div className="project-description">
                       <Text fontSize="sm" py={2} classname="project-description">
                         {"A platform enabling you contribute to charities and submit charity requests."}
                       </Text>
                       </div>
                       <HStack spacing={2}>
                       <a
                              
                              href="https://charityhero.vercel.app/"
                              target="_blank" rel="noopener noreferrer"
                              color="white"
                              className="project-deployed-link"
                            >
                              <BiLogoNetlify/>
                           
                             
                            </a>
                            <a
                              target="_blank" rel="noopener noreferrer"
                              href="https://github.com/Abhishree-codes/tart-clover-1298"
                              color="white"
                              className="project-github-link"
                            >
                              <AiFillGithub/>
                           
                             
                            </a>
                      
                       </HStack>
                       <HStack className="project-tech-stack" flexWrap="wrap" pt={4} spacing={2}>
                         
                           <Badge
                             my={2}
                             
                             colorScheme={"white"}
                           >
                             HTML
                           </Badge>
                           <Badge
                             my={2}
                             
                             colorScheme={"white"}
                           >
                             React
                           </Badge>
                           <Badge
                             my={2}
                             
                             colorScheme={"white"}
                           >
                             Chakra UI
                           </Badge>
                       
                       </HStack>
                     </CardBody>
                   </Stack>
                 </Card>
                 <Card key={5}  
                 className="project-card"
       _hover={{
        boxShadow: `0 0 20px 3px ${Tokens.blue.shades['400']}`,

      }}
       background={"transparent"}
       direction={{
                   base: "column",
                 }}
                 overflow="hidden"
                 border={ `1px solid rgba(190, 190, 190, 0.2)`}
         borderRadius= '8px'
         background-image= {`linear-gradient(to bottom, #030518, #05071a, #06081b, #080a1d, #090b1f, #0a0c20, #0b0d21, #0c0e22, #0d0f23, #0e1023, #0e1024, #0f1125)`}
         backdropFilter= {`blur(10px)`}
         color= 'white'
         padding={"16px"}
         
                 >
                  
       <Image align={"left"} objectFit="cover" maxH={"200px"} src={"https://res.cloudinary.com/dsixdct6o/image/upload/v1695073292/CharityHeroHeader_y4d0rv.png"} boxShadow={ `0 0 50px 10px #1c1c42`} />
    
                   <Stack>
                     <CardBody align="left" h={[null, "40vh"]}>

                       <Heading classname="project-title"  text={"SoundWave"} size="sm">first</Heading>
                       <div className="project-description">
                       <Text fontSize="sm" py={2} classname="project-description">
                         {"An e-commerce platform for selling audio devices such as headphones, earpods etc."}
                       </Text>
                       </div>
                       <HStack spacing={2}>
                       <a
                              
                              href="https://startling-mermaid-fc7ad8.netlify.app/"
                              target="_blank" rel="noopener noreferrer"
                              color="white"
                              className="project-deployed-link"
                            >
                              <BiLogoNetlify/>
                           
                             
                            </a>
                            <a
                              target="_blank" rel="noopener noreferrer"
                              href="https://github.com/Abhishree-codes/nippy-flavor-9468"
                              color="white"
                              className="project-github-link"
                            >
                              <AiFillGithub/>
                           
                             
                            </a>
                      
                       </HStack>
                       <HStack className="project-tech-stack" flexWrap="wrap" pt={4} spacing={2}>
                         
                           <Badge
                             my={2}
                             
                             colorScheme={"white"}
                           >
                             HTML
                           </Badge>
                           <Badge
                             my={2}
                             
                             colorScheme={"white"}
                           >
                             React
                           </Badge>
                           <Badge
                             my={2}
                             
                             colorScheme={"white"}
                           >
                             Chakra UI
                           </Badge>
                       
                       </HStack>
                     </CardBody>
                   </Stack>
                 </Card>
        </SimpleGrid>

        </>
    
    )
}

// Hi, my name is Abhishree Tripathi. I'm a Masai School student currently studying to become proficient in the MERN stack.

// Coding caught my interest in 2021 in the middle of my Psychology degree and since then I've been working towards beginning my career as a software developer. What excites me about creating software is the constant need for elegant problem-solving and potentially helping people in their daily-lives is an incredibly rewarding aspect as well. Equally, I'm looking forward to the life-long learning that comes with it, there will always be a cool new technology to get stuck into on the horizon :)

// Overall, I strive to become a developer that produces simple but great-quality code. This is why I am currently looking for my first software developer role to work in collaboration with others at a company with the same values as mine.